var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navlists"},[_c('div',{staticClass:"navtitle"},[_vm._v(_vm._s(_vm.navlist.name))]),_vm._l((_vm.navlist.list),function(i,j){return _c('div',{key:j,staticClass:"listsingle",class:_vm.choose == j ? 'activenavs' : '',on:{"click":function($event){return _vm.choosepath(j, i.index)}}},[_vm._v("\n    "+_vm._s(i.name)+"\n  ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }